import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setMetricDropdowns } from '../store/actions/team.actions';
import { trainingAPI } from "../api/TrainingAPI";

export const useMetricDropdowns = (metricTypes) => {
  const dispatch = useDispatch();
  const dropdowns = useSelector(state => state.team.dropdowns);
  const isLoading = useSelector(state => state.team.isLoading);
  const error = useSelector(state => state.team.error);

  useEffect(() => {
    const fetchDropdowns = async () => {
      const metricsToFetch = metricTypes.filter(type => !dropdowns[type]?.length);
      
      if (metricsToFetch.length === 0) return;

      try {
        const data = await trainingAPI.getDropdowns({ metricTypes: metricsToFetch });
        
        metricsToFetch.forEach(metric => {
          const treeData = data[`${metric}_tree`] || [];
          dispatch(setMetricDropdowns(metric, treeData));
        });
      } catch (error) {
        console.error('Failed to fetch dropdowns:', error);
      }
    };

    fetchDropdowns();
  }, [dispatch]);

  return { 
    dropdowns: metricTypes.length === 1 ? dropdowns[metricTypes[0]] : dropdowns,
    isLoading,
    error 
  };
};